export default function Footer() {
  return (
    <footer className="bg-[#03060f] text-white py-4">
      <div className="container mx-auto text-center">
        <p className="text-sm">&copy; 2025 Morze Tech Ltd.</p>
      </div>
    </footer>
  );
}